export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ADMINS = 'admins',

	PRODUCT_MODULES = 'product-modules',
	PRODUCT_MODULES_CATEGORIES = 'product-module-categories',
	PROJECTS = 'projects',
	LANDSCAPE_MODUELS = 'landscape-modules',
	PRODUCT_MODULE_COLLECTIONS = 'product-module-collections',
	MATERIALS = 'materials',
	MODELS = 'models',
	PLAYGROUND_FILLINGS = 'playgorund-fillings',
	ROLES = 'roles',
	MERCHANTS = 'merchants',
	CATEGORIES = 'categories',
	CONTENT = 'content',
	STORES = 'stores',
}
